import CmsComponent from "@/helpers/editor/components/CmsComponent.js";
import store from "@/store.js";
import CompatibilityHelper from "@/helpers/CompatibilityHelper.js";

export default class CmsComponentText extends CmsComponent {

    get allowBinding() {
        return true;
    }
    get allowMediaQuery() {
        return true;
    }
    get contentFields() {
        return [`text`, `newText`];
    }
    get translationFields() {
        return [`text`];
    }

    type = `text`

    // static PRESETS = {
    //     DEFAULT: { id: `default`, name: `Default|Défaut`, tag: `div` },
    //     PARAGRAPH: { id: `paragraph`, name: `Paragraph|Paragraphe`, tag: `p` },
    //     H1: { id: `h1`, name: `Title 1|Titre 1`, tag: `h1` },
    //     H2: { id: `h2`, name: `Title 2|Titre 2`, tag: `h2` }
    // }

    constructor(data) {
        super(data);

        if (!data) {
            this.bold = false;
            this.italic = false;
            this.underline = false;
            this.uppercase = false;
            this.letterSpacing = 1;
            this.lineHeight = 1;
            this.color = `default`;
            this.preset = `default`; // div p h1, h2, h3...
            this.format = undefined;

            this.advanced = false;
            this.leftIcon = null;
            this.rightIcon = null;
            this.prefix = {};
            this.suffix = {};
            this.widget = false;

            this.text = {};

            // Item Binding
            this.textField = null;
        } else {
            this.color = CompatibilityHelper.checkColor(this.color);
        }

        if (this.advanced === undefined) {
            this.advanced = false;
        }

        this.newText = this.text;
    }

    // do not init in constructor because cmsWebsite is not ready yet
    initText(text = { en: ``, fr: `` }, preset = `default`) {
        this.text = store.state.website.makeI18nText(text);
        this.newText = this.text;
        this.preset = preset;
    }

    getComponentTag() {
        switch (this.mediaProxy.preset) {
            case `p1`:
            case `p2`:
            case `p3`:
            case `p4`:
            case `p5`:
            case `p6`:
                return `p`;
            case `default`:
                return `div`;
            default:
                return this.mediaProxy.preset;
        }
    }

    getText(lang) {
        return this.text[lang];
    }

    applyChanges(language) {
        this.text = this.newText;
    }
}
